<template>
  <div class="w-full">
    <div class="gm-admin-kv">
      <div class="gm-admin-kv__head">
        <p class="w-3/12">
          {{ this.$t('frontend_groovemail_segment_subscribe_sender_name') }}
        </p>
        <p class="w-6/12">
          {{ this.$t('frontend_groovemail_segment_subscribe_sender_email') }}
        </p>
        <p class="w-3/12">
          {{ this.$t('frontend_analytics_gateway') }}
        </p>
      </div>
      <div
        class="gm-admin-kv__row"
        v-for="(sender, index) in sendersGatewayData"
        :key="index"
      >
        <p class="w-3/12">{{ sender.sender_name }}</p>
        <p class="w-6/12">{{ sender.sender_email }}</p>
        <p class="w-3/12">{{ getDriver(sender.driver) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import getSmtpDriverName from '@/components/getSmtpDriverName';

export default {
  name: 'senders-detail',
  props: {
    sendersGatewayData: {
      required: true,
    },
  },

  components: {
    VuePerfectScrollbar,
  },

  methods: {
    /**
     * Return driver SMTP type based on driver type.
     * @param {driver} driver driver type
     * @return {string} driver SMTP type
     */
    getDriver(driver) {
      return getSmtpDriverName(driver);
    },
  },
};
</script>
